import React from "react";
import { Badge, colors } from "../design/badge";
import { HolidayScheduleStatus } from "../models/HolidayScheduleStatus";

interface HolidayScheduleStatusBadgeProps {
  status: HolidayScheduleStatus;
}

const HolidayScheduleStatusBadge: React.FC<HolidayScheduleStatusBadgeProps> = ({
  status,
}) => {
  let color;
  let title;

  switch (status) {
    case "live":
      color = "green";
      title = "Live";
      break;
    case "draft":
      color = "blue";
      title = "Draft";
      break;
    case "archived":
      color = "red";
      title = "Archived";
      break;
    default:
      color = "yellow"; // Default color if status is unknown
      title = status;
  }

  return <Badge color={color as keyof typeof colors}>{title}</Badge>;
};

export default HolidayScheduleStatusBadge;
